/* web/app/components/layout/main/header/navbar-mobile/navbar-mobile.component.scss */
:host ::ng-deep .mat-drawer-backdrop {
  position: fixed;
}
:host ::ng-deep mat-sidenav {
  min-width: 320px;
}
/*# sourceMappingURL=navbar-mobile.component.css.map */
